import { PersonalIdTypeEnum } from 'app/models';

export class PersonalIdType {
    public static PersonalIdTypeList: Array<any> = [
        { name: 'Driver’s License', value: PersonalIdTypeEnum.DriverLicense },
        { name: 'Passport', value: PersonalIdTypeEnum.Passport },
        { name: 'Tin Card', value: PersonalIdTypeEnum.TinCard },
        { name: 'Health ID', value: PersonalIdTypeEnum.HealthId },
        { name: 'OFW ID', value: PersonalIdTypeEnum.OfwId },
        { name: 'Voters ID', value: PersonalIdTypeEnum.VotersId },
        { name: 'UMID ID', value: PersonalIdTypeEnum.UmidId },
        { name: 'National ID', value: PersonalIdTypeEnum.NationalId },
        { name: 'PRC ID', value: PersonalIdTypeEnum.PrcId },
    ];
}
